export const customDashboardConfigConstants = {
  GET_CUSTOM_DASHBOARDS_REQUEST: 'CHART/GET_CUSTOM_DASHBOARDS_REQUEST',
  GET_CUSTOM_DASHBOARDS_SUCCESS: 'CHART/GET_CUSTOM_DASHBOARDS_SUCCESS',
  GET_CUSTOM_DASHBOARDS_ERROR: 'CHART/GET_CUSTOM_DASHBOARDS_ERROR',

  GET_SELECTED_CUSTOM_DASHBOARD_REQUEST: 'CHART/GET_SELECTED_CUSTOM_DASHBOARD_REQUEST',
  GET_SELECTED_CUSTOM_DASHBOARD_SUCCESS: 'CHART/GET_SELECTED_CUSTOM_DASHBOARD_SUCCESS',
  GET_SELECTED_CUSTOM_DASHBOARD_ERROR: 'CHART/GET_SELECTED_CUSTOM_DASHBOARD_ERROR',

  UPDATE_CHART_CONFIGS: 'CHART/UPDATE_CHART_CONFIGS',
  EDIT_DASHBOARD_STATUS: 'CHART/EDIT_DASHBOARD_STATUS',

  SELECTED_CUSTOM_DASHBOARD: 'CHART/SELECTED_CUSTOM_DASHBOARD',

  ADD_CHART_CONFIGS: 'CHART/ADD_CHART_CONFIGS',

  GET_NICKNAME_LIST: 'CHART/GET_NICKNAME_LIST',
  IS_LOADING_CHART: 'CHART/IS_LOADING_CHART',
  UPDATE_CONFIG: 'CHART/UPDATE_CONFIG',

  GET_MAPPING_REQUEST: 'CHART/GET_MAPPING_REQUEST',
  GET_MAPPING_SUCCESS: 'CHART/GET_MAPPING_SUCCESS',
  GET_MAPPING_ERROR: 'CHART/GET_MAPPING_ERROR',

  GET_SELECTED_DASHBOARD_CONFIG_REQUEST:
    "CHART/GET_SELECTED_DASHBOARD_CONFIG_REQUEST",
  GET_SELECTED_DASHBOARD_CONFIG_SUCCESS:
    "CHART/GET_SELECTED_DASHBOARD_CONFIG_SUCCESS",
  GET_SELECTED_DASHBOARD_CONFIG_FAILED:
    "CHART/GET_SELECTED_DASHBOARD_CONFIG_FAILED",
  ADD_CHART_TO_VISUALISATION_SET: "ADD_CHART_TO_VISUALISATION_SET",

  DIMENSION_LIST: "CHART/DIMENSION_LIST",
  CHROME_METRICS_LIST: "CHART/CHROME_METRICS_LIST",
  UPDATE_ROW_LIMIT: "CHART/UPDATE_ROW_LIMIT",
  UPDATE_CHART_GRANULARITY: "CHART/UPDATE_CHART_GRANULARITY"
};
